import { RevisionItem } from "../RevisionItem";
import { createRevisionClassResource } from "../../revision";
import {
  apiField,
  constructFromApiData,
  getApiPostData,
  getDiff,
  itemApiField,
  nestedItemArrayApiField,
  revisionApiField,
} from "../ResourceItemMetadata";
import { ResourceItem, IncompleteResourceItem } from "../ResourceItem";
import { getListDiff } from "../diff";

export class ProductListUnit extends ResourceItem {
  @revisionApiField()
  product!: IncompleteResourceItem;

  @itemApiField(ResourceItem)
  responsibleUser: ResourceItem | null = null;

  constructor(data?: any) {
    super(data);
    if (data) constructFromApiData(this, data);
  }

  getPostData() {
    return { ...getApiPostData(this) };
  }
}

function productListUnitIsEqual(a: ProductListUnit, b: ProductListUnit) {
  return (
    (a.product && a.product.id) === (b.product && b.product.id) &&
    (a.responsibleUser && a.responsibleUser.id) ===
      (b.responsibleUser && b.responsibleUser.id)
  );
}

export class ProductList extends RevisionItem {
  @apiField()
  name!: string;

  @nestedItemArrayApiField(ProductListUnit, {
    getDiff: getListDiff(productListUnitIsEqual, (unit) => unit.product!.id),
  })
  units: ProductListUnit[] = [];

  constructor(data?: any) {
    super(data);
    if (data) constructFromApiData(this, data);
  }

  getPostData() {
    return { ...super.getPostData(), ...getApiPostData(this) };
  }

  getDiff(other: this) {
    return getDiff(this, other);
  }
}

interface ProductListSimple {
  id: number;
  str: string;
  units: ProductListUnit[];
  rowKey: string;
}

export const productListResource = createRevisionClassResource<
  ProductList,
  ProductListSimple
>("plm/productList/", ProductList);
